import { setSnackbar } from 'flow/actions/app-actions';
import Button, { colors } from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch } from 'flow/hooks/useRedux';

interface Props {
    data: string;
    className?: string;
    color?: keyof typeof colors;
}

const CopyToClipboardButton = ({ data, className, color }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const copyToClipboard = () => {
        navigator.clipboard.writeText(data).then(() => {
            dispatch(
                setSnackbar({
                    message: i18next.t('snackbar.copied_to_clipboard'),
                }),
            );
        });
    };

    return (
        <Button
            color={color}
            onClick={copyToClipboard}
            iconKey="copy"
            className={className}
        />
    );
};

export default CopyToClipboardButton;
